export default "__VITE_ASSET__DK2LVqvd__";